"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeField = exports.DateField = exports.CalendarField = void 0;

require("./CalendarField.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
    Calendar
    
    The calendar component. 
    Handles the time- and date field

    Verified by: Yorben Verhoest
    Date: 05/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/
// Returns both time and date together
var CalendarField = function CalendarField(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "calendar"
  }, /*#__PURE__*/_react["default"].createElement(TimeField, props), /*#__PURE__*/_react["default"].createElement(DateField, props));
}; // Returns only the time field


exports.CalendarField = CalendarField;

var TimeField = function TimeField(props) {
  return /*#__PURE__*/_react["default"].createElement("input", {
    className: "inputField calendarTime ".concat(props.template ? "temp_".concat(props.template) : ""),
    disabled: props.disabled ? true : false,
    onChange: function onChange(e) {
      return props.onChangeTime(e);
    },
    placeholder: props.placeholder_time,
    type: "time",
    value: props.value_time,
    "aria-label": props.label
  });
}; // Returns only the date field


exports.TimeField = TimeField;

var DateField = function DateField(props) {
  return props.title ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "form__group datefield"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: props.title,
    className: "form__label"
  }, props.title), /*#__PURE__*/_react["default"].createElement("input", {
    className: "inputField calendarDate ".concat(props.template ? "temp_".concat(props.template) : ""),
    disabled: props.disabled ? true : false,
    onBlur: function onBlur(e) {
      return props.onBlurDate(e);
    },
    onChange: function onChange(e) {
      return props.onChangeDate(e);
    },
    placeholder: props.placeholder_date,
    defaultValue: props.defaultValue,
    type: "date",
    value: props.value_date,
    "aria-label": props.label,
    format: props.format
  })) : /*#__PURE__*/_react["default"].createElement("input", {
    className: "inputField calendarDate ".concat(props.template ? "temp_".concat(props.template) : ""),
    disabled: props.disabled ? true : false,
    onBlur: function onBlur(e) {
      return props.onBlurDate(e);
    },
    onChange: function onChange(e) {
      return props.onChangeDate(e);
    },
    placeholder: props.placeholder_date,
    defaultValue: props.defaultValue,
    type: "date",
    value: props.value_date,
    "aria-label": props.label,
    format: props.format
  });
};

exports.DateField = DateField;